export const columnTitlesToBeCentered = ['Active', 'Actions'];
